import React from 'react';
import { ROLES } from './roles';

// Importação dos componentes de página para cada rota
import LandingPage from '../pages/LandingPage';
// Páginas de Autenticação
import LoginPage from '../pages/auth/LoginPage';
import RegisterPage from '../pages/auth/RegisterPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';

// Páginas do Painel Administrativo
import AdminDashboardPage from '../pages/admin/dashboard/AdminDashboardPage';
import UserManagementPage from '../pages/admin/userManagement/UserManagementPage';
import ClientManagementPage from '../pages/admin/clientManagement/ClientManagementPage';
import CampaignManagementPage from '../pages/admin/campaignManagement/CampaignManagementPage';
import ReportsPage from '../pages/admin/reports/ReportsPage';
import SystemSettingsPage from '../pages/admin/systemSettings/SystemSettingsPage';

// Páginas do Sistema de Caixa
import CashierDashboardPage from '../pages/cashier/CashierDashboardPage';

// Páginas do Aplicativo do Cliente
import ClientDashboardPage from '../pages/client/dashboard/ClientDashboardPage';
import CampaignsPage from '../pages/client/campaigns/CampaignsPage';
import TransactionHistoryPage from '../pages/client/history/TransactionHistoryPage';
import ProfilePage from '../pages/client/profile/ProfilePage';
import UnitsMapPage from '../pages/client/units/UnitsMapPage';

// Páginas Comuns para tratamento de erros ou não encontradas
import NotFoundPage from '../pages/common/NotFoundPage';
import ErrorPage from '../pages/common/ErrorPage';

export type RouteType = {
  path: string;
  element: React.ReactNode;
  label: string;
  role?: string | null;
  icon?: string;
  hideInMenu?: boolean;
};

import { useAuth } from '../contexts/AuthContext';
import EmailValidatorPage from '@/pages/auth/EmailValidatorPage';
import PoliticaPrivacidadePage from '@/pages/auth/PoliticaPrivacidadePage';
import TermosCondicoesPage from '@/pages/auth/TermosCondicoesPage';

// Hook personalizado para gerenciar as rotas com base na autenticação
const useRoutes = () => {
  const { usuario, usuarioFirebase } = useAuth(); // ✅ ADICIONADO: usuarioFirebase

  let rotas: RouteType[] = [];

  if (!usuario) {
    rotas = [
      {
        path: '/',
        element: <LandingPage />,
        label: 'LandingPage',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/login',
        element: <LoginPage />,
        label: 'Login',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/cadastro',
        element: <RegisterPage />,
        label: 'Registrar',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/recuperar-senha',
        element: <ForgotPasswordPage />,
        label: 'Recuperar Senha',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/termos-condicoes',
        element: <TermosCondicoesPage />,
        label: 'Termos e Condições',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/politica-privacidade',
        element: <PoliticaPrivacidadePage />,
        label: 'Política de Privacidade',
        role: null,
        hideInMenu: true,
      },
      {
        path: '/validar-email',
        element: <EmailValidatorPage />,
        label: 'Validar Email',
        role: null,
        hideInMenu: true,
      },
    ];
  }
  else if (usuario.tipo_usuario === ROLES.ADMINISTRADOR) {
    rotas = [
      {
        path: '/',
        element: <AdminDashboardPage />,
        label: 'Dashboard Admin',
        role: ROLES.ADMINISTRADOR,
        icon: 'dashboard',
      },
      {
        path: '/home',
        element: <AdminDashboardPage />,
        label: 'Dashboard Admin',
        role: ROLES.ADMINISTRADOR,
        icon: 'dashboard',
      },
      {
        path: '/usuarios',
        element: <UserManagementPage />,
        label: 'Gestão de Usuários',
        role: ROLES.ADMINISTRADOR,
        icon: 'people',
      },
      {
        path: '/clientes',
        element: <ClientManagementPage />,
        label: 'Gestão de Clientes',
        role: ROLES.ADMINISTRADOR,
        icon: 'business',
      },
      {
        path: '/relatorios',
        element: <ReportsPage />,
        label: 'Relatórios',
        role: ROLES.ADMINISTRADOR,
        icon: 'analytics',
      },
      {
        path: '/erro',
        element: <ErrorPage />,
        label: 'Erro',
        hideInMenu: true,
      },
      {
        path: '*',
        element: <NotFoundPage />,
        label: 'Página Não Encontrada',
        hideInMenu: true,
      }
    ];
  }
  else if (usuario.tipo_usuario === ROLES.OPERADOR) {
    rotas = [
      // Rotas do Sistema de Caixa
      {
        path: '/',
        element: <CashierDashboardPage />,
        label: 'Caixa PDV',
        role: ROLES.OPERADOR,
        icon: 'point_of_sale',
      },
      {
        path: '/home',
        element: <CashierDashboardPage />,
        label: 'Caixa PDV',
        role: ROLES.OPERADOR,
        icon: 'point_of_sale',
      },
      {
        path: '/erro',
        element: <ErrorPage />,
        label: 'Erro',
        hideInMenu: true,
      },
      {
        path: '*',
        element: <NotFoundPage />,
        label: 'Página Não Encontrada',
        hideInMenu: true,
      }
    ];
  }
  else {
    // ✅ CORREÇÃO: Verifique o email verificado do Firebase, não seu campo customizado
    const emailValidado = usuarioFirebase?.emailVerified;

    if (emailValidado) {
      rotas = [
        {
          path: '/',
          element: <ClientDashboardPage />,
          label: 'Meu Dashboard',
          role: null,
          icon: 'dashboard',
        },
        {
          path: '/home',
          element: <ClientDashboardPage />,
          label: 'Meu Dashboard',
          role: null,
          icon: 'dashboard',
        },
        {
          path: '/campanhas',
          element: <CampaignsPage />,
          label: 'Campanhas',
          role: null,
          icon: 'campaign',
        },
        {
          path: '/historico',
          element: <TransactionHistoryPage />,
          label: 'Histórico de Transações',
          role: null,
          icon: 'history',
        },
        {
          path: '/unidades',
          element: <UnitsMapPage />,
          label: 'Unidades',
          role: null,
          icon: 'location_on',
        },
        {
          path: '/perfil',
          element: <ProfilePage />,
          label: 'Meu Perfil',
          role: null,
          icon: 'person',
        },
        {
          path: '/termos-condicoes',
          element: <TermosCondicoesPage />,
          label: 'Termos e Condições',
          role: null,
          hideInMenu: true,
        },
        {
          path: '/politica-privacidade',
          element: <PoliticaPrivacidadePage />,
          label: 'Política de Privacidade',
          role: null,
          hideInMenu: true,
        },
        {
          path: '/erro',
          element: <ErrorPage />,
          label: 'Erro',
          hideInMenu: true,
        },
        {
          path: '*',
          element: <NotFoundPage />,
          label: 'Página Não Encontrada',
          hideInMenu: true,
        }
      ];
    } else {
      rotas = [
        {
          path: '/',
          element: <EmailValidatorPage />,
          label: 'Validar Email',
          role: null,
          icon: 'email',
          hideInMenu: true,
        },
        {
          path: '/validar-email',
          element: <EmailValidatorPage />,
          label: 'Validar Email',
          role: null,
          hideInMenu: true,
        },
        {
          path: '/erro',
          element: <ErrorPage />,
          label: 'Erro',
          hideInMenu: true,
        },
        {
          path: '*',
          element: <EmailValidatorPage />, // ✅ Redireciona para validação de email
          label: 'Validar Email',
          hideInMenu: true,
        }
      ];
    }
  }

  return rotas;
};

export const routes = useRoutes;